<template>
<section :class="{'is-satellite-mode': isSatelliteMode}" class="map-data-wrapper">
  <map-player-ctrl-bar
    :record-screen-title="`${windProfileDevice ? `${siteMap[windProfileDevice.siteId].name} ${currentChartType.label}` : ''}`"
    @record-screen="onRecordScreen"
  >
    <a-map ref="map" satellite-mode />
    <map-tool-wind-speed-rose
      ref="mapToolWindSpeedRose"
      :type="currentChartType.type"
      :color-list="currentChartType.colorList"
      :min-val="currentChartType.minVal"
      :max-val="currentChartType.maxVal"
      :color-bar-val-interval="currentChartType.colorInterval"
      :unit="currentChartType.unit"
    />
  </map-player-ctrl-bar>

  <section v-show="operatorCoverVisible" class="operator-cover"></section>

  <section class="tool-bar">
    <el-date-picker
      v-model="queryDate"
      type="date"
      format="yyyy年MM月dd日"
      value-format="yyyy/MM/dd"
      :clearable="false"
      :editable="false"
      size="small"
      popper-class="dark-el-popper"
      style="float:left;width:180px;"
      @focus="onQueryDateFocus"
      @change="onQueryDateChanged"
      @blur="onQueryDateBlur"
    />

    <el-radio-group
      v-model="chartTypeVal"
      size="small"
      style="float:left;margin-left:1rem;"
      @change="onChartTypeValChanged"
    >
      <el-radio-button
        v-for="chartType in chartTypes"
        :key="chartType.value"
        :label="chartType.value"
      >{{chartType.label}}</el-radio-button>
    </el-radio-group>

    <el-radio-group
      v-model="isSatelliteMode"
      size="small"
      style="float:left;margin-left:1rem;"
      @change="onSatelliteModeChanged"
    >
      <el-radio-button :label="true">卫星地图</el-radio-button>
      <el-radio-button :label="false">电子地图</el-radio-button>
    </el-radio-group>
  </section>

  <section v-show="!operatorCoverVisible" class="site-select-section">
    <section class="site-select-section-inner">
      <el-tree
        ref="site-tree"
        :data="siteTree"
        :props="{label:'name'}"
        node-key="id"
        default-expand-all
        highlight-current
        @current-change="onSiteTreeSelectChanged"
      />
    </section>
  </section>
</section>
</template>

<script>
import BaseStore from '../../../../../components/BaseStore'
import AMap from '../../../../../components/Map/index'
import {CHART_TYPES} from './constants'
import MapPlayerCtrlBar from '../../../../../components/MapTools/PlayerCtrlBar/index'
import MapToolWindSpeedRose from '../../../../../components/MapTools/WindSpeedRose/index'

import windSpeedRoseEventKeyMap from '@/components/MapTools/WindSpeedRose/eventKeyMap'

export default {
  name: 'DataDisplayWindProfileMap',
  routeInfo: {
    label: '地图',
    icon: 'fa fa-users'
  },
  extends: BaseStore,
  components: {MapToolWindSpeedRose, MapPlayerCtrlBar, AMap},
  data () {
    return {
      operatorCoverVisible: false,
      queryDate: new Date().format('YYYY/MM/DD'),
      chartTypeVal: CHART_TYPES[0].value,
      windProfileDevice: null,
      isScreenCap: false,
      isSatelliteMode: true
    }
  },
  computed: {
    chartTypes: () => CHART_TYPES,
    currentChartType () {
      let {chartTypeVal} = this
      return this.chartTypes.find(chartType => chartType.value === chartTypeVal)
    },
    siteMap () {
      return this.profileSites.reduce((map, site) => {
        map[site.id] = site
        return map
      }, {})
    },
    windProfileLidarSiteIdMap () {
      return this.profileSiteDevices.filter(siteDevice => siteDevice.categoryId === process.env.WIND_PROFILE_CATEGORY).reduce((map, windProfileLidar) => {
        let {siteId} = windProfileLidar
        let siteDevices = map[siteId]

        if (!siteDevices) {
          siteDevices = map[siteId] = []
        }

        siteDevices.push({
          id: windProfileLidar.id,
          name: windProfileLidar.name,
          categoryId: windProfileLidar.categoryId,
          siteId
        })

        return map
      }, {})
    },
    siteTree () {
      let {windProfileLidarSiteIdMap} = this
      return JSON.parse(JSON.stringify(this.profileSites.filter(site => windProfileLidarSiteIdMap[site.id]))).map(({id}) => {
        return windProfileLidarSiteIdMap[id]
      }).flat()
    }
    /**
    siteTree () {
      let {windProfileLidarSiteIdMap} = this
      return JSON.parse(JSON.stringify(this.profileSites.filter(site => windProfileLidarSiteIdMap[site.id]))).map(({id, name}) => ({
        id,
        name,
        children: windProfileLidarSiteIdMap[id]
      }))
      // let sites = JSON.parse(JSON.stringify(this.profileSites.filter(site => windProfileLidarSiteIdMap[site.id])))
      // let siteTree = []
      //
      // sites.reduce((tmpMap, site) => {
      //   let {province, city} = site
      //   let provinceData = tmpMap[province]
      //
      //   if (!provinceData) {
      //     provinceData = tmpMap[province] = {
      //       id: province,
      //       name: province,
      //       children: {}
      //     }
      //
      //     siteTree.push(provinceData)
      //   }
      //
      //   let provinceChildren = provinceData.children
      //   let cityData = provinceChildren[city]
      //
      //   if (!cityData) {
      //     cityData = provinceChildren[city] = {
      //       id: city,
      //       name: city,
      //       children: []
      //     }
      //   }
      //
      //   let siteId = site.id
      //
      //   cityData.children.push({
      //     id: siteId,
      //     name: site.name,
      //     // longitude: site.longitude,
      //     // latitude: site.latitude,
      //     children: windProfileLidarSiteIdMap[siteId]
      //   })
      //
      //   return tmpMap
      // }, {})
      //
      // siteTree.forEach(province => {
      //   province.children = Object.values(province.children)
      // })
      //
      // return siteTree
    }
    **/
  },
  methods: {
    getData () {
      let {windProfileDevice} = this

      if (!windProfileDevice) {
        return
      }

      this.changeLoadStatus(true)

      let {currentChartType, queryDate} = this
      let windProfileDeviceId = windProfileDevice.id
      let {apiKey} = currentChartType
      let query = {
        beginTime: `${queryDate} 00:00:00`,
        endTime: `${queryDate} 23:59:59`,
        dataType: 1,
        siteDeviceId: windProfileDeviceId,
        apiPath: apiKey
      }

      this.q = JSON.stringify(query)

      this.$api.Data.getWindProfileMapData(apiKey, query).then(({lngLat, fileList}) => {
        this.lngLat = lngLat

        if (fileList instanceof Array && fileList.length > 0) {
          let oFileList = [...fileList]
          let firstFileName = fileList.shift()
          let dataList = []

          this.getJSONFile(firstFileName, lngLat, fileList, dataList, this.q, data => {
            this.$eventBus.emit('MapPlayerDataChanged', {
              lngLatChangeKey: windSpeedRoseEventKeyMap.LNG_LAT_CHANGE,
              dataChangeKey: windSpeedRoseEventKeyMap.DATA_CHANGE,
              dataClearKey: windSpeedRoseEventKeyMap.dataClearKey,
              tsList: oFileList.map(filename => parseInt(/(?:_)(\d+)(?:\.|_)/.exec(filename)[1])),
              dataList
            })

            if (this.isScreenCap) {
              this.setMapOffset()
            }
          })
        } else {
          this.lngLat = null
          this.$eventBus.emit('MapPlayerDataChanged', {
            dataClearKey: windSpeedRoseEventKeyMap.CLEAR
          })
        }
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    getJSONFile (fileName, lngLat, fileList, dataList, queryStr, callback) {
      this.$api.Data.getJSONData(fileName).then(data => {
        if (queryStr !== this.q) {
          return
        }

        data.lngLat = lngLat
        dataList.push(data)
        callback && callback(data)
        fileName = fileList.shift()

        if (fileName) {
          this.getJSONFile(fileName, lngLat, fileList, dataList, queryStr)
        }
      }).catch(console.error)
    },
    setMapOffset () {
      let lngLat = this.lngLat

      if (lngLat) {
        setTimeout(() => {
          let refMap = this.$refs.map

          if (refMap) {
            let mapLngLat = refMap.lngLat(...lngLat)
            refMap.handleSetCenter(mapLngLat.offset(1650, 500))
          }
        }, 500)
      }
    },
    onQueryDateFocus (datePicker) {
      this.operatorCoverVisible = true
    },
    onQueryDateChanged (queryDate) {
      this.getData()
    },
    onQueryDateBlur (datePicker) {
      this.operatorCoverVisible = false
    },
    onChartTypeValChanged () {
      this.getData()
    },
    onSiteTreeSelectChanged (treeNode) {
      let {windProfileDevice} = this

      if (Array.isArray(treeNode.children)) {
        this.$refs['site-tree'].setCurrentKey(windProfileDevice ? windProfileDevice.id : null)
        return
      }

      if (!windProfileDevice || windProfileDevice.id !== treeNode.id) {
        this.windProfileDevice = Object.freeze(JSON.parse(JSON.stringify(treeNode)))
        this.getData()
      }
    },
    onRecordScreen () {
      this.setMapOffset()
    },
    onSatelliteModeChanged (isSatelliteMode) {
      this.$refs.map.onSatelliteModeChange(isSatelliteMode)
    }
  },
  mounted () {
    this.$refs.map.onSatelliteModeChange(true)
  }
}
</script>

<style lang="scss" scoped>
.map-data-wrapper {
  $BORDER-COLOR: rgba(255, 255, 255, .5);
  $BACKGROUND-COLOR: rgba(0, 0, 0, .3);
  $COLOR: #ffffff;

  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;

  .site-select-section {
    position: absolute;
    top: 60px;
    left: 10px;
    width: 180px;
    height: 300px;
    padding: 10px 0;
    border: 1px solid $BORDER-COLOR {
      radius: 3px;
    };
    background-color: $BACKGROUND-COLOR;
    box-shadow: 0 0 20px 4px rgba(255, 255, 255, .15);
    overflow: hidden;
    user-select: none;

    .site-select-section-inner {
      width: 100%;
      height: 100%;
      overflow: auto;

      .el-tree {
        background-color: transparent;
        color: $COLOR;

        &.el-tree--highlight-current {
          /deep/ {
            .el-tree-node {
              > .el-tree-node__content {
                &:hover {
                  background-color: rgba(255, 255, 255, .2);
                }
              }

              &.is-current {
                > .el-tree-node__content {
                  background-color: rgba(255, 255, 255, .4);
                }
              }
            }
          }
        }

        /deep/ {
          .el-tree-node {
            &:focus {
              > .el-tree-node__content {
                background-color: transparent;
              }
            }
          }
        }
      }
    }
  }

  .operator-cover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
  }

  .tool-bar {
    position: absolute;
    top: 10px;
    left: 10px;
    user-select: none;
    z-index: 3;
  }

  .el-input {
    /deep/ {
      .el-input__inner {
        border-color: $BORDER-COLOR;
        background-color: $BACKGROUND-COLOR;
        color: $COLOR;
      }

      .el-input__icon {
        color: $COLOR;
      }
    }
  }

  .el-radio-button {
    &.is-active {
      /deep/ {
        .el-radio-button__inner {
          background-color: rgba(11, 138, 255, 0.4);
          color: $COLOR !important;
        }
      }
    }

    /deep/ {
      .el-radio-button__inner {
        border-color: $BORDER-COLOR;
        background-color: $BACKGROUND-COLOR;
        color: $COLOR;

        &:hover {
          /*background-color: rgba(255, 255, 255, .2);*/
          color: #409EFF;
        }
      }

      .el-radio-button__orig-radio {
        &:checked {
          & + .el-radio-button__inner {
            box-shadow: -1px 0 0 0 rgba(255, 255, 255, .3);
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/03Data-Display/98VerticalDetection/09WindProfile/10Map/index.vue